var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/info-menu/NotificationsIcon.tsx",
  _this = this;
import React from 'react';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { t, defineMessages } from '@sm/intl';
import { Box } from '@wds/box';
import { IconBell } from '@wds/icons';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';
import useStyles from './useStyles';
export var COPY = defineMessages({
  NOTIFICATION_CENTER: {
    id: 'NotificationsIcon.notificationCenter',
    defaultMessage: 'Notification center',
    description: '[Type: Label][Vis.: high] - This is the main text for the title of the this notifications feature.'
  },
  ICON_ALT_TEXT: {
    id: 'NotificationsIcon.altText',
    defaultMessage: 'Notification center icon',
    description: '[Type: Label][Vis.: high] - This is the alt text that displays to screens readers focused on the bell icon.'
  },
  MAX_COUNT: {
    id: 'NotificationsIcon.maxCount',
    defaultMessage: '9+',
    description: '[Type: Label][Vis.: high] - The badge displaying message count should be limited to a maximum of "9+".'
  },
  NAV_BUTTON_LABEL: {
    id: 'NotificationsIcon.navLabel',
    defaultMessage: 'See my notifications',
    description: '[Type: Label][Vis.: high] - Alt text for the navigation item since the navbutton since it contains only an icon.'
  }
});
var NotificationsIcon = function NotificationsIcon(_ref) {
  var showNotifications = _ref.showNotifications,
    toggleNotifications = _ref.toggleNotifications,
    unreadNotificationsCount = _ref.unreadNotificationsCount,
    pageName = _ref.pageName,
    pageURL = _ref.pageURL;
  var _useStyles = useStyles(),
    notificationsBadge = _useStyles.notificationsBadge,
    notificationsBadgeContainer = _useStyles.notificationsBadgeContainer,
    notificationsBadgeContainerMobile = _useStyles.notificationsBadgeContainerMobile;
  var trackNotificationsEvent = function trackNotificationsEvent() {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'notification center interaction',
        interactionType: 'click',
        interactionLocation: 'bell icon',
        messageCountUnread: unreadNotificationsCount,
        pageName: pageName,
        pageURL: pageURL
      }
    });
  };
  var maxUnreadNotificationsCount = unreadNotificationsCount > 9 ? t(COPY.MAX_COUNT) : unreadNotificationsCount;
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(NavButton, {
      onClick: function onClick() {
        toggleNotifications();
        trackNotificationsEvent();
      },
      label: t(COPY.NAV_BUTTON_LABEL),
      active: showNotifications,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 82,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Box, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 13
      }
    }, unreadNotificationsCount > 0 && /*#__PURE__*/React.createElement("div", {
      className: notificationsBadgeContainer,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: notificationsBadge,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 19
      }
    }, maxUnreadNotificationsCount)), /*#__PURE__*/React.createElement(IconBell, {
      title: t(COPY.ICON_ALT_TEXT),
      size: "lg",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 15
      }
    }))) : /*#__PURE__*/React.createElement(List.Item, {
      onClick: toggleNotifications,
      affordance: unreadNotificationsCount > 0 ? /*#__PURE__*/React.createElement("div", {
        className: notificationsBadgeContainerMobile,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 106,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: notificationsBadge,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107,
          columnNumber: 19
        }
      }, maxUnreadNotificationsCount)) : undefined,
      role: "button",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 11
      }
    }, t(COPY.NOTIFICATION_CENTER));
  });
};
export default NotificationsIcon;
export { NotificationsIcon };
//# sourceMappingURL=NotificationsIcon.js.map